import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');
import fontFamily from '../data/font-family';

const Badge = styled.span`
  ${({ bgColor }) => `background-color: ${colors[bgColor] || 'transparent'}`};
  ${({ fontColor }) => `color: ${colors[fontColor] || colors.N200}`};
  border-radius: 3px;
  display: inline-block;
  font-family: ${fontFamily};
  font-size: 12px;
  font-weight: 400;
  height: 24px;
  line-height: 24px;
  max-width: calc(100% - 16px);
  min-height: 24px;
  overflow: hidden;
  padding: 0 6px;
  text-overflow: ellipsis;
  vertical-align: top;
  white-space: nowrap;
`;

export default Badge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/Badge.js